import { useNavigate } from "react-router-dom";
import { useAuth } from "../App";
import { Button } from "../components/ui/button";
import { ArrowLeft, Eye } from "lucide-react";

const ImpersonationBanner = () => {
  const navigate = useNavigate();
  const { setAuthUser } = useAuth();

  const isImpersonating = localStorage.getItem("impersonating") === "true";
  const originalAdmin = JSON.parse(localStorage.getItem("original_admin_user") || "null");

  if (!isImpersonating || !originalAdmin) return null;

  const handleReturn = () => {
    const originalToken = localStorage.getItem("original_admin_token");
    localStorage.setItem("token", originalToken);
    localStorage.removeItem("original_admin_token");
    localStorage.removeItem("original_admin_user");
    localStorage.removeItem("impersonating");
    setAuthUser(originalAdmin);
    navigate("/super-admin");
    window.location.reload();
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-amber-500 text-white px-4 py-2 flex items-center justify-between shadow-lg" data-testid="impersonation-banner">
      <div className="flex items-center gap-2">
        <Eye className="w-4 h-4" />
        <span className="text-sm font-medium">
          Suplantando identidad — Estás viendo como otro usuario
        </span>
      </div>
      <Button size="sm" variant="secondary" onClick={handleReturn} data-testid="return-to-admin-btn">
        <ArrowLeft className="w-3 h-3 mr-1" />
        Volver a Super Admin
      </Button>
    </div>
  );
};

export default ImpersonationBanner;
